import React, { useEffect, useCallback } from "react";
import TableComponent from "@/components/mentoratComp/TableComp";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Plus, SearchIcon } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useMentorApi } from "@/api/MentorApi";
import { useMentoringStore } from "@/stores/mentoringStore";

const AddedMentor: React.FC = () => {
  const { deleteMentoring, mentorings } = useMentoringStore();
  const { getAllMentorings } = useMentorApi();
  const navigate = useNavigate();

  const fetchMentorings = useCallback(async () => {
    const res = await getAllMentorings();

    // 1. Check if the response exists and was successful
    if (!res || !res.success || !res.data || res.data.length === 0) {
      return;
    }

    // Use res.data here...
  }, [getAllMentorings]);

  useEffect(() => {
    fetchMentorings();
  }, [fetchMentorings]);

  const handleDelete = (id: number) => {
    if (
      window.confirm("Are you sure you want to delete this mentoring entry?")
    ) {
      deleteMentoring(id);
    }
  };

  const gotoAddMentorList = () => {
    navigate("/jeuneInnovateur/mentorat/listeMentors");
  };

  return (
    <div className="min-h-screen bg-white mt-4 p-4">
      <div>
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-6 sm:mb-8">
          <div className="relative w-full sm:max-w-xs md:max-w-md">
            <span className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-[#3D4C5E]">
              <SearchIcon className="w-4 h-4 sm:w-5 sm:h-5" />
            </span>
            <Input
              placeholder="Rechercher un mentor..."
              className="pl-9 w-full h-10 sm:h-12 bg-[#F6F8F9] rounded-xl sm:rounded-2xl text-sm text-[#3D4C5E] border-none focus-visible:ring-2 focus-visible:ring-blue-200"
            />
          </div>

          <Button
            className="hidden sm:flex bg-[#0286BD] h-12 text-white font-medium px-4 rounded-[18px] 
            transition-all duration-300 hover:bg-[#0275a8] hover:shadow-md
            active:bg-[#026492] items-center gap-2 w-full sm:w-auto"
            onClick={gotoAddMentorList}
          >
            <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-300">
              <Plus size={14} className="text-white" />
            </div>
            <span>Ajouter un mentor</span>
          </Button>
        </div>

        <div className="bg-white rounded-lg sm:rounded-xl shadow-sm border overflow-hidden">
          {/* Show fallback message if there are no mentorings */}
          {mentorings.length === 0 ? (
            <div className="text-center p-8 text-gray-500">
              <p>Aucune donnée de mentorat disponible pour le moment.</p>
              <p>Veuillez ajouter un mentor pour commencer.</p>
            </div>
          ) : (
            <TableComponent
              data={mentorings}
              onDelete={handleDelete}
              checkboxColor="#F6F8F9"
            />
          )}
        </div>

        <div className="sm:hidden fixed bottom-6 right-6 z-10">
          <Button
            className="bg-[#0286BD] h-14 w-14 rounded-full p-0 shadow-lg
            hover:bg-[#0275a8] active:bg-[#026492] transition-all duration-200"
            onClick={gotoAddMentorList}
          >
            <Plus size={24} className="text-white" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddedMentor;
